import SchemaOverview from './SchemaOverview'

const ROUTES = [
  SchemaOverview
]

export default ROUTES
